import { createStore } from ".";
import { createJSONStorage } from "zustand/middleware";

interface GeoCoords {
  latitude: number;
  longitude: number;
}

interface GeoState {
  coords: GeoCoords | null;
  setCoords: (coords: GeoCoords) => void;
  clearCoords: () => void;
}

export const useGeoStore = createStore<GeoState>(
  (set) => ({
    coords: null,
    setCoords: (coords) => set({ coords }),
    clearCoords: () => set({ coords: null }),
  }),
  {
    // 탭 종료/새로고침 후에도 마지막 위치를 기억하도록 localStorage에 영속
    name: "parkgolf-geo",
    storage: createJSONStorage(() => localStorage),
  },
);
